module.exports = __webpack_public_path__ + "static/media/ic_reports.f24189d8.svg";